module.exports = __webpack_public_path__ + "img/boy_left.2f0d11c5.svg";